import { render } from "./SigninPage.vue?vue&type=template&id=f8ffc842&scoped=true"
import script from "./SigninPage.vue?vue&type=script&lang=js"
export * from "./SigninPage.vue?vue&type=script&lang=js"

import "./SigninPage.vue?vue&type=style&index=0&id=f8ffc842&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ffc842"]])

export default __exports__